// extracted by mini-css-extract-plugin
module.exports = {"AlbumSearchCell":"AlbumSearchCell-AlbumSearchCell-3loiz TableRowCell-cell-2fbg4"};